// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"sa-z"};